(function () {
	let isInitialized = false;
	let elsInitialized = false;

	const els = Array.from(
		document.querySelectorAll(".vl-block-articles-highlight")
	);

	const foundEl = els.length > 0;

	document.addEventListener("DOMContentLoaded", () => {
		if (!isInitialized) {
			isInitialized = true;

			if (foundEl) {
				init();
			}
		}
	});

	function initializeEls() {
		els.map((item) => {
			// let's add tracking type for the block
			item.classList.add("js-track-list-item");
		});

		elsInitialized = true;
	}

	function init() {
		initializeEls();
	}
})();
